export const CLIENT_ID_KEY = 'client_id'
export const RETURN_URL_KEY = 'redirect_uri'
